import { render, staticRenderFns } from "./BookingsReports.vue?vue&type=template&id=6b16f9ce"
import script from "./BookingsReports.vue?vue&type=script&lang=js"
export * from "./BookingsReports.vue?vue&type=script&lang=js"
import style0 from "./BookingsReports.vue?vue&type=style&index=0&id=6b16f9ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports